import { render, staticRenderFns } from "./UniversalLoginComponent.vue?vue&type=template&id=257684a8&"
import script from "./UniversalLoginComponent.vue?vue&type=script&lang=js&"
export * from "./UniversalLoginComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports